<script lang="ts">
	import { attrs } from '#library/attrs.ts'
	import type { Blok, Collagousel } from '#library/components.schema.build.ts'
	import Render from '#components/render.svelte'
	import Image from '#components/image.svelte'

	interface Props {
		blok: Blok<Collagousel>
	}

	let { blok }: Props = $props()
</script>

<section class="collagousel {blok.theme}" {...attrs(blok)}>
	<div class="contain" class:alt={blok.alt}>
		<div>
			{#if blok.title?.text}
				<svelte:element this={blok.title?.tag || 'div'} class="title">
					{blok.title.text}
				</svelte:element>
			{/if}
			{#if blok.body}
				<div class="body">
					<Render content={blok.body} />
				</div>
			{/if}
		</div>
		{#if blok.images?.length}
			<div>
				<div class="images">
					{#each blok.images as image, i (i)}
						{#if image.filename}
							<Image src={image.filename} alt={image.alt} focus={image.focus} />
						{/if}
					{/each}
				</div>
			</div>
		{/if}
	</div>
	<!-- <div class="pagi contain">
		<Pagination items={blok.images.length} alt />
	</div> -->
</section>

<style lang="css">
	.collagousel {
		background-color: var(--c-background);
		color: var(--c-foreground);
		padding-block: var(--padding-top, var(--padding-default)) var(--padding-bottom, var(--padding-default));
	}

	.contain {
		align-items: center;
		display: grid;
		gap: 4rem;

		@media (--from-mobile) {
			grid-template-columns: minmax(0, 1fr) minmax(0, 1fr);
		}
	}

	.title {
		font: 600 var(--f-h2);
		letter-spacing: var(--ls-h2);
	}

	.body {
		color: var(--c-midground);
		font: 400 var(--f-body1);
		letter-spacing: var(--ls-body1);
		margin-block: 1.5rem 0;

		:global {
			.link {
				color: var(--c-foreground);
				margin-block-start: 2rem;
			}
		}
	}

	.images {
		display: inline-block;
		margin-block: var(--s-164) var(--s-40);

		:global {
			.image {
				aspect-ratio: 1;
				height: auto;
				max-width: 18.5rem;
				z-index: 1;

				@media (--from-mobile) {
					max-width: 22.5rem;
				}
			}

			.image:nth-child(2) {
				inset: -50% auto auto 50%;
				max-width: 16rem;
				position: absolute;
				z-index: 0;

				@media (--from-mobile) {
					max-width: 20rem;
				}
			}

			.image:nth-child(3) {
				inset: 15% auto auto 150%;
				max-width: 12rem;
				position: absolute;
				z-index: 0;

				@media (--from-mobile) {
					max-width: 16rem;
				}
			}
		}
	}

	.pagi {
		grid-template-columns: 1fr;

		:global {
			.count {
				opacity: 0;
				pointer-events: none;
			}
		}
	}
</style>
